import PropTypes from 'prop-types';
import { default as React, useEffect, useState } from "react";
import { Accordion, Alert, Badge, ListGroup, Card } from 'react-bootstrap';
import 'react-loading-skeleton/dist/skeleton.css';
import useToken from "../../hooks/useToken";


const SeccionHarwareLicencia = ({
    idLicencia,
    setMensajeError,
    setShowMensajeError,
}) => {

    const [hardware, setHardware] = useState([]);
    const { token, setToken } = useToken();

    /**
    * Obtiene detalles
    */
    const ObtenerListaHardware = async () => {

        const response = await fetch("/api/licencia/ObtenerListaHardware/?idLicencia=" + idLicencia, {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                setShowMensajeError(true);
                setMensajeError('' + error.message);
                console.log('Hubo un problema con la peticion Fetch:' + error.message);
            });

        if (response.ok) {

            //console.log(response);
            const data = await response.json();

            setHardware(data);

        }
        else {
            setShowMensajeError(true);
            setMensajeError(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
    };

    useEffect(() => {
        ObtenerListaHardware();
    }, []);

    return (

        hardware.length > 1 && (
            <Card className="mb-3">
                <ListGroup variant="flush">
                    <ListGroup.Item>
                        <Accordion defaultActiveKey={['0']} >
                            <Accordion.Item >
                                <Accordion.Header>
                                    <Badge bg="danger" className="me-2 dark__bg-dark"> {hardware.length} </Badge> Violaci&oacute;n de uso
                                </Accordion.Header>
                                <Accordion.Body>
                                    <ListGroup variant="flush" className="fs--3">
                                        <ListGroup.Item>
                                            <Alert variant="danger"> <span>Se detect&oacute; que esta licencia ha sido instalada en al menos {hardware.length} dispositivos diferentes. De acuerdo a nuestros t&eacute;rminos y condiciones, solo es posible usar esta licencia en 1 PC.</span> </Alert>

                                            <ListGroup variant="flush">

                                                {hardware.map((hw, index) => {
                                                    return <ListGroup.Item key={index} className="border-top" >
                                                        <Badge bg="warning" className="me-2 dark__bg-dark"> {hw.NUM} pings</Badge>{hw.vDatosPcLogIn}
                                                    </ListGroup.Item>
                                                })}

                                            </ListGroup>
                                        </ListGroup.Item>
                                    </ListGroup>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </ListGroup.Item>
                </ListGroup>
            </Card>
        )

    )
}

SeccionHarwareLicencia.propTypes = {
    idLicencia: PropTypes.string,
    setMensajeError: PropTypes.func,
    setShowMensajeError: PropTypes.func,
};

export default SeccionHarwareLicencia;